module.exports = __webpack_public_path__ + "img/ThumbDownAltOutlined.dff51353.svg";